<template>
	<div class="add_backimg add_backimgTop">
		<div class="index_banner">
			<el-carousel height="400px" trigger="click" :autoplay="true">
				<el-carousel-item v-for="(item,index) in banners" :key='item.id'>
					<img :src="baseurl + item.imageUrl" class="banner_img" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="content">
			<div class="index_labList">
				<img src="@/images/index_listBack.png" class="index_labBack" />
				<div class="index_labLable">
					<img src="@/images/index_lableIcon1.png" class="index_lableIcon" />
					<div class="index_lableText">Medical image simulation thread</div>
					<div class="index_lableType">
						<img src="@/images/index_typeBack.png" />
						<span>虚拟仿真实验</span>
					</div>
				</div>
				<div class="index_labMain">
					<img src="@/images/index_listBackIn.png" class="index_listBackIn" />
					<div class="index_types">
						<img src="@/images/index_types.png" class="index_typesBack" />
						<div class="index_typeBox">
							<div class="index_typeItem text-ellipsis" :class="typeId == null ?'active':''" @click="handleClick(null)">
								<img src="@/images/type_back.png" />
								<span>全部</span>
							</div>
							<div class="index_typeItem text-ellipsis" :class="item.id == typeId ?'active':''" v-for="(item, index) in majorList" @click="handleClick(item.id)" v-if="index<6">
								<img src="@/images/type_back.png" />
								<span>{{item.name}}</span>
							</div>
							<div class="index_listMore" @click="toName('fictitious')"> 更多<i class="el-icon-arrow-right"></i></div>
						</div>
					</div>
					<div class="index_listBox">
						<emptymain :emptytext="'暂无实验'" :emptylist='experiments'></emptymain>
						<div class="right_itemlab" v-for="(item,index) in experiments">
							<div class="right_coverLab">
								<div class="right_coverImg coverItem">
									<img :src="baseurl + item.cover" />
								</div>
								<div class="right_collect" @click.stop="simulationCollection(item)">
									<div class="right_collectNormal">
										<img src="@/images/collected.png" v-if="item.isCollection" />
										<img src="@/images/collecting.png" v-if="!item.isCollection" />
										<span>{{item.collectionCount || 0}}</span>
									</div>
									<div class="right_collectHover">
										<span v-if="item.isCollection">取消收藏</span>
										<span v-if="!item.isCollection">点击收藏</span>
									</div>
								</div>
								<div class="right_type">
									{{item.typeName || "虚拟仿真实验"}}
								</div>
							</div>
							<div class="lab_title text-ellipsistwo">【{{item.mode == '3'?'训练':'考核'}}】{{item.name}}</div>
							<div class="lab_click">{{item.clicks || 0}}人已浏览</div>
							<div class="right_labBtn">
								<div class="right_labBtnBox clearfix">
									<div class="right_labBtnMore clearfix">
										<div class="right_labClick l" @click="viewSimulation(item)" v-if="item.mode == '3'">
											<img src="@/images/index_inTest.png" />
											<span>进入<br />训练</span>
										</div>
										<div class="right_labClick r" @click="viewSimulation(item)" v-if="item.mode == '2' && item.vrExamineState == 1">
											<img src="@/images/index_inExam.png" />
											<span>进入<br />考核</span>
										</div>
									</div>
									<div class="right_labBtnIt" @click="getLabInfo(item)">实验详情 <i class="el-icon-arrow-right"></i></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="index_labList">
				<img src="@/images/index_listBack.png" class="index_labBack" />
				<div class="index_labLable">
					<img src="@/images/index_lableIcon2.png" class="index_lableIcon" />
					<div class="index_lableText">Medical image simulation Course</div>
					<div class="index_lableType">
						<img src="@/images/index_typeBack.png" />
						<span>在线课程</span>
					</div>
				</div>
				<div class="index_labMain">
					<img src="@/images/index_listBackIn.png" class="index_listBackIn" />
					<div class="index_types">
						<img src="@/images/index_types.png" class="index_typesBack" />
						<div class="index_typeBox">
							<div class="index_typeItem text-ellipsis" :class="coursetypeId == null ?'active':''" @click="typeChange(null)">
								<img src="@/images/type_back.png" />
								<span>全部</span>
							</div>
							<div class="index_typeItem text-ellipsis" :class="item.id == coursetypeId ?'active':''" v-for="(item, index) in majorList" @click="typeChange(item.id)"  v-if="index<6">
								<img src="@/images/type_back.png" />
								<span>{{item.name}}</span>
							</div>
							<div class="index_listMore" @click="toName('courses')"> 更多<i class="el-icon-arrow-right"></i></div>
						</div>
					</div>
					<div class="index_listBox">
						<emptymain :emptytext="'暂无课程'" :emptylist='courses'></emptymain>
						<div class="index_courseItem" @click.stop="toCourseindex(item)" v-for="(item,index) in courses">
							<div class="right_coverItem">
								<div class="right_coverImg coverItem">
									<img :src="baseurl + item.banner" />
								</div>
								<div class="right_collect" @click.stop="moocCollection(item)">
									<div class="right_collectNormal">
										<img src="@/images/collected.png" v-if="item.isCollection" />
										<img src="@/images/collecting.png" v-if="!item.isCollection" />
										<span>{{item.collectionCount || 0}}</span>
									</div>
									<div class="right_collectHover">
										<span v-if="item.isCollection">取消收藏</span>
										<span v-if="!item.isCollection">点击收藏</span>
									</div>
								</div>
								<div class="right_play">
									<img src="@/images/normal.png" class="normal" />
									<img src="@/images/hovered.png" class="hovered" />
								</div>
							</div>
							<div class="right_infoTitle text-ellipsistwo">{{item.name}}</div>
							<div class="right_infoDesc text-ellipsistwo">{{item.info}}</div>
							<div class="right_infoStudy">{{item.signCount || 0}}人学习</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<img @click="openUrl" src="@/images/index_ad.png" class="index_ad" v-if="indexAdShow"/>
		<div class="content">
			<div class="index_others clearfix">
				<div class="index_othersLeft">
					<div class="index_othersLabel">
						<img src="@/images/index_news.png" />
						<span>最新资讯</span>
						<span class="index_othersMore" @click="toName('news')">更多<i class="el-icon-arrow-right"></i></span>
					</div>
					<div class="index_othersCont">
						<emptymain :emptytext="'暂无资讯'" :emptylist='noticeList'></emptymain>
						<div class="new_listItem clearfix" :class="item.cover?'hascover':''" v-for="item in noticeList" @click="toDetails(item)">
							<div class="new_listIcon coverItem" v-if="item.cover">
								<img :src="baseurl + item.cover" />
							</div>
							<div class="new_listDate">
								<div class="new_listDay">{{item.releaseTime | spliceForDay}}</div>
								<div class="new_listMonth">{{item.releaseTime | spliceForYear}}</div>
							</div>
							<div class="new_listInfo clearfix">
								<div class="new_listTitle text-ellipsis">{{item.title}}</div>
								<div class="new_listDesc text-ellipsistwo">{{item.description}}</div>
								<div class="new_listOther clearfix">
									<div class="new_listIn">校内资讯</div>
									<div class="new_listNum">{{item.readCount || 0}}人已读</div>
									<img src="@/images/new_listRight.png" class="new_listRight" />
									<img src="@/images/new_listRightAct.png" class="new_listRightAct" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="index_othersRight">
					<div class="index_othersLabel">
						<img src="@/images/index_labs.png" />
						<span>热门实验</span>
						<span class="index_othersMore" @click="toName('fictitious')">更多<i class="el-icon-arrow-right"></i></span>
					</div>
					<div class="index_othersCont index_othersContLab clearfix">
						<emptymain :emptytext="'暂无实验'" :emptylist='experimentHots'></emptymain>
						<div class="right_indexlab" v-for="(item,index) in experimentHots">
							<div class="right_coverLab">
								<div class="right_coverImg coverItem">
									<img :src="baseurl + item.cover" />
								</div>
								<div class="right_collect" @click.stop="simulationCollection(item)">
									<div class="right_collectNormal">
										<img src="@/images/collected.png" v-if="item.isCollection" />
										<img src="@/images/collecting.png" v-if="!item.isCollection" />
										<span>{{item.collectionCount || 0}}</span>
									</div>
									<div class="right_collectHover">
										<span v-if="item.isCollection">取消收藏</span>
										<span v-if="!item.isCollection">点击收藏</span>
									</div>
								</div>
								<div class="right_type">
									{{item.typeName || "虚拟仿真实验"}}
								</div>
							</div>
							<div class="lab_title text-ellipsistwo">【{{item.mode == '3'?'训练':'考核'}}】{{item.name}}</div>
							<div class="lab_click">{{item.clicks || 0}}人已浏览</div>
							<div class="right_labBtn">
								<div class="right_labBtnBox clearfix">
									<div class="right_labBtnMore clearfix">
										<div class="right_labClick l" @click="viewSimulation(item)" v-if="item.mode == '3'">
											<img src="@/images/index_inTest.png" />
											<span>进入<br />训练</span>
										</div>
										<div class="right_labClick r" @click="viewSimulation(item)" v-if="item.mode == '2' && item.vrExamineState == 1">
											<img src="@/images/index_inExam.png" />
											<span>进入<br />考核</span>
										</div>
									</div>
									<div class="right_labBtnIt" @click="getLabInfo(item)">实验详情 <i class="el-icon-arrow-right"></i></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { bannerList } from '@/api/banner'
	import { getListNoPager, appCourseList } from '@/api/course'
	import { majormainDO, listMajorByPid } from '@/api/major'
	import { noticeList, userIsRead } from '@/api/notice'
	import { vrDetailPage, vrPaperUserInit } from '@/api/simulation'
	import { collectionSave, collectionDelete } from '@/api/collection'
	import { userCollectionSave, userCollectionRemove, saveResourceDetailRecord } from '@/api/simulation.js'
	import { getStorageToken } from '@/utils/auth'
	export default {
		name: 'index',
		data() {
			return {
				current: 1,
				limit: 3,
				total: 0,
				majorList: [],
				experiments: [],
				experimentHots: [],
				typeId: null,
				coursetypeId: null,
				typeList: [],
				courses: [],
				banners: [],
				noticeList: [],
				indexAdShow:window.config.INDEX_AD_SHOW,
			}
		},
		created() {
			this.getMajormainDO();
			this.gettVrPaperDO();
			this.getCourse();
			this.getBanner();
			this.getNotice();
		},
		mounted() {

		},
		methods: {
			openUrl(){
				window.open(window.config.INDEX_AD_URL)
			},
			getBanner() {
				bannerList({
					majorId: this.majorIdForAll,
				}).then(res => {
					this.banners = res.data;
				})
			},
			typeChange(id) {
				this.coursetypeId = id;
				this.getCourse();
			},
			getCourse() {
				var data = {
					majorId: this.majorIdForAll,
					typeId: this.coursetypeId == this.majorIdForAll ? null : this.coursetypeId,
					current: 1,
					limit: 4,
				}
				appCourseList(data).then(res => {
					if(res.code == "OK") {
						this.courses = res.data.records;
					}
				})
			},
			//课程导航切换
			getMajormainDO() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.majorList = res.data || [];
				})
			},
			//展示热门实验列表页
			gettVrPaperDOHot() {
				var data = {
					majorId: this.majorIdForAll,
					current: 1,
					limit: 2,
					hotSign:'1',
				}
				vrDetailPage(data).then(res => {
					this.experimentHots = res.data.records || [];
				})
			},
			gettVrPaperDO() {
				var data = {
					majorId: this.majorIdForAll,
					typeId: this.typeId,
					current: 1,
					limit: 4,
				}
				vrDetailPage(data).then(res => {
					this.experiments = res.data.records || [];
				})
				this.gettVrPaperDOHot();
			},
			//点击切换相应课程——展示列表
			handleClick(id) {
				this.typeId = id;
				this.gettVrPaperDO();
			},
			getLabInfo(item) {
				this.$router.push({
					name: 'fictitiousinfo',
					query: {
						vrDetailId: item.id,
						resourceId: item.resourceId,
					}
				})
			},
			viewSimulation(item) {
				var vrDetailId = item.id;
				var resourceId = item.resourceId;
				var token = getStorageToken();
				if(token) {
					saveResourceDetailRecord({
						vrDetailId: vrDetailId,
						resourceId: resourceId,
					}).then(res => {
						if(item.version == '2.2.0') {
							window.open('#/fictitiousdetail?type=data&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
						} else if(item.mode && item.mode == '2') {
							if(item.version == '2.0.0') {
								window.open('#/fictitiousdetail?type=exam&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
							} else {
								vrPaperUserInit({
									vrDetailId: vrDetailId,
									resourceId: resourceId,
									expertype: item.typeId,
								}).then(res => { //判断是否有关联的试卷，存在则直接返回，不存在则创建后返回
									if(res.code == 'OK') {
										window.open('#/fictitiousdetail?type=index&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId + '&pid=' + res.data)
									}
								})
							}
						} else {
							window.open('#/fictitiousdetail?type=test&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toCourseindex(item) {
				this.$router.push({
					name: 'coursedetail',
					query: {
						courseId: item.id
					}
				})
			},
			toName(name) {
				var token = getStorageToken();
				if(token) {
					if(this.$router.name != name) {
						this.$router.push({
							name: name
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			handleCurrentChange(current) {
				this.current = current;
				this.getNotice()
			},
			getNotice() {
				var data = {
					current: this.current,
					limit: this.limit,
					state: 1
				}
				noticeList(data).then(res => {
					if(res.code == 'OK') {
						this.noticeList = res.data.records;
						this.total = res.data.total;
					}
				})
			},
			toDetails(item) {
				userIsRead({notice_id: item.id});
				this.$router.push({
					name: "newsdetail",
					query: {
						id: item.id
					}
				})
			},
			//仿真收藏
			simulationCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						userCollectionSave({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.gettVrPaperDO();
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						userCollectionRemove({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.gettVrPaperDO();
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			moocCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						collectionSave({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.getCourse();
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						collectionDelete({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.getCourse();
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
		},
	}
</script>